import BaseModule from './BaseModule'
import jsx from 'babel-plugin-syntax-jsx'

class Login extends BaseModule {
  constructor() {
    super()
  }
  // 获取首页基础数据
  getLogin(params){
      // var params = {
      //   account:params.account,
      //   password:hex_md5(params.password)
      // }
      return this.post(`/api/access/token`,params)
  }
  getNotice(params){
      return this.get(`/api/notice`,params)
  }

  getCode(params) {//获取验证码
    return this.post(`/api/pwd/send-security-code`,params)
  }

  resetPwd(params) {//重置密码
    return this.post(`/api/pwd/reset`,params)
  }
}

export default new Login()



// WEBPACK FOOTER //
// ./src/api/Login.js